import momentTz from 'moment-timezone';
import moment from 'moment';

export const getDatetimeEST = () => {
  const current = new Date().toString();
  const estDateObj = momentTz(current).tz('America/Toronto');
  return new Date(estDateObj.format('LLL'));
};

export const getCurrentESThour = () => {
  const regex = /(\d+):(\d+):(\d+)/;
  const result = regex.exec(getDatetimeEST().toTimeString());
  return result[1];
};

export const checkIfCurrentDateIsTheDayAfterInEst = () => {
  const current = new Date();
  return current.toDateString() !== getDatetimeEST().toDateString();
};

export const getDatetimeESTsummingHours = (numberOfHours) => new Date(getDatetimeEST().setHours(getDatetimeEST().getHours() + numberOfHours));

export const formatLossDateToEST = (lossDate) => {
  const lossDateEst = momentTz(lossDate).tz('America/Toronto', true).toJSON();
  return moment(lossDateEst).utc().format('YYYY-MM-DD hh:mm a');
};
